import React from 'react';
import { Message, openButtonsModal } from '@weezevent/nacre';
import i18n from 'i18next';
import { Trans } from 'react-i18next';

export async function askClose(cb) {
    return openButtonsModal({
        title: i18n.t('context_menu.modal.title'),
        details: (
            <Message type="danger">
                <Trans i18nKey="context_menu.modal.body" />
            </Message>
        ),
        buttons: [
            {
                label: i18n.t('ticket.common.action.cancel')
            },
            {
                label: i18n.t('context_menu.modal.button'),
                destructive: true,
                onClick: cb
            }
        ]
    });
}
